import { render, staticRenderFns } from "./CellRendererManage.vue?vue&type=template&id=47c2bdd6&scoped=true&"
import script from "./CellRendererManage.vue?vue&type=script&lang=js&"
export * from "./CellRendererManage.vue?vue&type=script&lang=js&"
import style0 from "./CellRendererManage.vue?vue&type=style&index=0&id=47c2bdd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c2bdd6",
  null
  
)

export default component.exports